import { render, staticRenderFns } from "./UploadFileDIY.vue?vue&type=template&id=5ae73d90"
import script from "./UploadFileDIY.vue?vue&type=script&lang=js"
export * from "./UploadFileDIY.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports